import { PropsWithChildren } from 'react';
import { useTranslation } from 'next-i18next';

import { LayoutWrapper } from './wrapper-layout';
import FallbackSpinner from '../components/fallback-spinner';

/**
 * Props for the EmployerSecondaryLayout component.
 *
 * @interface EmployerSecondaryLayoutProps
 * @property {string} pageTitle - The title locale key of the page to be displayed.
 * @property {string} [title] - An title to be displayed in the layout.
 */
interface EmployerSecondaryLayoutProps {
  pageTitle?: string;
  title?: string;
  hideNavigation?: boolean;
}

export function EmployerSecondaryLayout({
  children,
  pageTitle: pageTitleLocaleKey,
  title,
  hideNavigation,
}: PropsWithChildren<EmployerSecondaryLayoutProps>) {
  const { t: translateCommon } = useTranslation('common');

  return (
    <LayoutWrapper hideNavigation={hideNavigation} title={title || translateCommon(pageTitleLocaleKey)}>
      <FallbackSpinner />
      {children}
    </LayoutWrapper>
  );
}

export default EmployerSecondaryLayout;
